/* Leia & Batce — simgym-v1 (LAB-195, 2026-11-02). Plain script, no imports. Loaded from snippets/cart-drawer.liquid
   (the drawer is on every page). Fixes what Shopify SimGym's AI shoppers stalled on (run cmvxicg7w01u8ak1c6hv43e0p):

   F  Filters: while results reload, the grid says so (results-list[aria-busy] + a thin progress line); after the
      re-render, phones scroll the results top into view; PostHog lb_filter_applied {source, filters, count, ms}.
      The active line itself ("Showing 10 pieces · Polo ×") is Liquid (snippets/lb-type-chips.liquid).
   D  Drawer "10% off your first order": the email posts the footer's newsletter customer form via fetch, then LAB10
      goes on through Horizon's own discount component (window.lbCodes, assets/lb-your-codes.js). A bot challenge
      falls back to a normal submit. "Have a code?" drives the same component. PostHog lb_drawer_signup {result},
      lb_drawer_code {result}; lb_signup_code comes from lbCodes.link.
   C  Cart line: after an add, the new line is highlighted for ~1.5 s and "Added: <title>, <options>" is announced. */
(function () {
  if (window.__lbSimgym) return;
  window.__lbSimgym = true;

  var html = document.documentElement;
  var PHONE = window.matchMedia('(max-width: 749px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CODE = 'LAB10';
  function ph(name, props) { try { if (window.posthog && window.posthog.capture) window.posthog.capture(name, props || {}); } catch (e) {} }
  function held() { try { return JSON.parse(localStorage.getItem('lb_codes') || '[]'); } catch (e) { return []; } }
  function drawer() { return document.getElementById('cart-drawer'); }
  function squash(s) { return String(s || '').replace(/\s+/g, ' ').trim(); }

  // ---- one polite announcer for the whole page --------------------------------------------------------
  function say(text) {
    var el = document.getElementById('lb-announce');
    if (!el) {
      el = document.createElement('div');
      el.id = 'lb-announce'; el.className = 'visually-hidden';
      el.setAttribute('role', 'status'); el.setAttribute('aria-atomic', 'true');
      document.body.appendChild(el);
    }
    el.textContent = '';
    setTimeout(function () { el.textContent = text; }, 60);
  }

  // ---- D: first-order 10% + "Have a code?" -------------------------------------------------------------
  function syncHolds() { html.classList.toggle('lb-holds-lab10', held().indexOf(CODE) !== -1); }

  function showError(el, text) {
    if (!el) return;
    el.textContent = text; el.hidden = !text;
  }
  function busy(btn, on, label) {
    if (!btn) return;
    if (on) { btn.dataset.lbLabel = btn.textContent; btn.textContent = label || 'Applying…'; btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    else { btn.textContent = btn.dataset.lbLabel || 'Apply'; btn.disabled = false; btn.removeAttribute('aria-busy'); }
  }
  function appliedNow() { return window.lbCodes && window.lbCodes.applied ? window.lbCodes.applied() : []; }

  // After LAB10 is submitted to Horizon's component the drawer re-renders; if it did not stick, say so plainly.
  function confirmApplied(code, onFail) {
    var tries = 0;
    var t = setInterval(function () {
      if (appliedNow().indexOf(code) !== -1) { clearInterval(t); return; }
      if (++tries > 14) { clearInterval(t); onFail(); }
    }, 250);
  }

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function signup(form) {
    var input = form.querySelector('input[type="email"]');
    var err = form.querySelector('[data-lb-fo-error]');
    var btn = form.querySelector('[data-lb-fo-submit]');
    var v = squash(input && input.value);
    if (!EMAIL.test(v)) {
      showError(err, 'Please check the email address.');
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
      ph('lb_drawer_signup', { result: 'invalid' });
      return;
    }
    if (input) input.removeAttribute('aria-invalid');
    showError(err, '');
    busy(btn, true);
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', redirect: 'follow' })
      .then(function (r) {
        var u = r.url || '';
        if (/\/challenge/.test(u)) {                       // Shopify's bot check: let the browser handle it
          ph('lb_drawer_signup', { result: 'challenge' });
          HTMLFormElement.prototype.submit.call(form);
          return;
        }
        var ok = /customer_posted=true/.test(u);
        ph('lb_drawer_signup', { result: ok ? 'ok' : 'other', status: r.status });
        joined();
      })
      .catch(function () {
        busy(btn, false);
        ph('lb_drawer_signup', { result: 'network' });
        showError(err, "Couldn't reach the store just now. Try again, or use LAB10 at checkout.");
      });
  }

  function joined() {
    if (window.lbCodes) {
      window.lbCodes.hold(CODE);
      window.lbCodes.link(CODE, 'drawer');                 // sets the checkout code too (express buttons included)
      window.lbCodes.apply(CODE);
    }
    say('You are on the list. Applying LAB10.');
    confirmApplied(CODE, function () {
      var offer = document.querySelector('#cart-drawer [data-lb-fo-offer]');
      if (offer) {
        offer.innerHTML = '';
        var p = document.createElement('p');
        p.className = 'lb-fo__done'; p.setAttribute('role', 'status');
        p.innerHTML = '<span class="lb-fo__done-title">You’re on the list.</span> Use <strong>LAB10</strong> at checkout for 10% off.';
        offer.appendChild(p);
      }
      ph('lb_drawer_signup', { result: 'apply_failed' });
    });
    syncHolds();
  }

  function codeSubmit(form) {
    var input = form.querySelector('input[name="code"]');
    var code = squash(input && input.value).toUpperCase();
    var details = form.closest('details');
    var errId = 'lb-fo-code-error';
    if (!code) { showError(document.getElementById(errId), 'Enter a code.'); if (input) input.focus(); return; }
    showError(document.getElementById(errId), '');
    if (!window.lbCodes) return;
    busy(form.querySelector('button'), true);
    window.lbCodes.hold(code);
    window.lbCodes.apply(code);
    var tries = 0;
    var t = setInterval(function () {
      var on = appliedNow().indexOf(code) !== -1;
      var bad = window.lbCodes.lastError && window.lbCodes.lastError();
      if (on || bad || ++tries > 14) {
        clearInterval(t);
        ph('lb_drawer_code', { result: on ? 'ok' : 'rejected', code: code });
        if (on) {
          say(code + ' applied.');
          var done = document.querySelector('#cart-drawer [data-lb-fo-code]');
          if (done) {
            done.open = false;
            var di = done.querySelector('input'); if (di) di.value = '';
            busy(done.querySelector('button'), false);
          }
          return;
        }
        var d = document.querySelector('#cart-drawer [data-lb-fo-code]');
        if (d) d.open = true;
        var f = d && d.querySelector('[data-lb-fo-code-form]');
        if (f) { var i = f.querySelector('input'); if (i) { i.value = code; i.setAttribute('aria-invalid', 'true'); } busy(f.querySelector('button'), false); }
        showError(document.getElementById(errId), 'That code doesn’t work for this cart.');
      }
    }, 250);
    if (details) details.open = true;
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    if (f.id === 'lb-first-order') { e.preventDefault(); e.stopPropagation(); signup(f); }
    else if (f.hasAttribute('data-lb-fo-code-form')) { e.preventDefault(); e.stopPropagation(); codeSubmit(f); }
  }, true);
  document.addEventListener('input', function (e) {
    var i = e.target;
    if (!(i instanceof HTMLInputElement) || !i.closest('[data-lb-fo]')) return;
    if (i.getAttribute('aria-invalid') === 'true') {
      i.removeAttribute('aria-invalid');
      var id = (i.getAttribute('aria-describedby') || '').split(' ').pop();
      showError(document.getElementById(id), '');
    }
  });
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-lb-fo-code]') && e.target.open) ph('lb_drawer_code', { result: 'opened' });
  }, true);

  // ---- F: filter feedback -----------------------------------------------------------------------------
  var pending = null, safety = 0, settleT = 0;
  function results() { return document.querySelector('results-list'); }
  function activeLabels() {
    return Array.prototype.map.call(document.querySelectorAll('[data-lb-active-pill]'), function (a) { return a.dataset.lbActivePill; });
  }
  function startFilter(source) {
    var r = results(); if (!r) return;
    r.setAttribute('aria-busy', 'true');
    pending = { source: source, t0: Date.now() };
    clearTimeout(safety); safety = setTimeout(endFilter, 6000);
  }
  function endFilter() {
    clearTimeout(safety);
    var r = results(); if (r) r.removeAttribute('aria-busy');
    if (!pending) return;
    var p = pending; pending = null;
    var box = document.querySelector('[data-lb-active]');
    var count = box ? Number(box.dataset.lbActiveCount) : Number((document.querySelector('[data-lb-count]') || {}).dataset ? document.querySelector('[data-lb-count]').dataset.lbCount : NaN);
    ph('lb_filter_applied', { source: p.source, filters: activeLabels(), count: isNaN(count) ? null : count, ms: Date.now() - p.t0 });
    // phones: the filters live in a drawer; once it's closed, make sure the shopper sees the top of the results
    if (PHONE.matches && !document.querySelector('dialog[open]')) revealResults();
  }
  function revealResults() {
    var top = document.querySelector('[data-lb-active]') || document.querySelector('.lb-chips') || results();
    if (!top) return;
    var y = top.getBoundingClientRect().top;
    if (y < 0 || y > window.innerHeight * 0.5) top.scrollIntoView({ block: 'start', behavior: REDUCED.matches ? 'auto' : 'smooth' });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t instanceof HTMLInputElement && t.closest('facets-form-component, .facets__form')) startFilter('sidebar');
  }, true);
  document.addEventListener('click', function (e) {
    var t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    if (t.closest('facet-remove-component')) startFilter('remove');
    // phones: closing the filter drawer after changes; bring the results into view
    if (PHONE.matches && t.closest('.facets__see-results, .facets-drawer__close, [ref="closeButton"]')) setTimeout(revealResults, 350);
  }, true);
  function watchResults() {
    var r = results(); if (!r || r.__lbWatched) return;
    r.__lbWatched = true;
    new MutationObserver(function (records) {
      if (!pending) return;
      var real = records.some(function (x) { return x.type === 'childList'; });
      if (!real) return;
      clearTimeout(settleT); settleT = setTimeout(endFilter, 150);
    }).observe(r, { childList: true, subtree: true });
  }

  // ---- C: highlight + announce the line that was just added -----------------------------------------------
  function variantIdFrom(target) {
    if (!(target instanceof Element)) return '';
    var i = target.querySelector('input[name="id"]') || (target.closest('form') && target.closest('form').querySelector('input[name="id"]'));
    return i ? String(i.value) : '';
  }
  function flash(row) {
    row.classList.remove('lb-line-flash');
    void row.offsetWidth;
    row.classList.add('lb-line-flash');
    setTimeout(function () { row.classList.remove('lb-line-flash'); }, 1700);
    var title = squash((row.querySelector('.cart-items__title') || {}).textContent);
    var opts = squash((row.querySelector('.cart-items__variants') || {}).textContent).replace(/\s·\s/g, ', ');
    say('Added: ' + title + (opts ? ', ' + opts : '') + '.');
  }
  function findRow(id) {
    var d = drawer(); if (!d || d.querySelector('[data-lb-optimistic]')) return null;
    if (id) return d.querySelector('tr.cart-items__table-row[data-key^="' + id + ':"]');
    return d.querySelector('tr.cart-items__table-row[data-key]');
  }
  document.addEventListener('shopify:cart:lines-update', function (event) {
    try {
      if (!event || event.action !== 'add') return;
      var id = variantIdFrom(event.target);
      var go = function () {
        var tries = 0;
        var t = setInterval(function () {
          var row = findRow(id);
          if (row) { clearInterval(t); flash(row); }
          else if (++tries > 20) clearInterval(t);
        }, 200);
      };
      if (event.promise && typeof event.promise.then === 'function') event.promise.then(function () { setTimeout(go, 400); }, function () {});
      else setTimeout(go, 1200);
    } catch (e) { /* never break the add */ }
  });

  function onReady() {
    syncHolds();
    watchResults();
    window.addEventListener('storage', function (e) { if (e.key === 'lb_codes') syncHolds(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady); else onReady();
})();
